$mapSize